import { compose } from "recompact"
import * as entity from "src/engine/modules/entity"
import planModel from "src/models/plan"
import collection from "src/hocs/collection"
import isFunction from "lodash/isFunction"

const configuration = {
  engine: entity,
  to: `plans`,
  model: planModel,
}

export default config =>
  compose(
    collection(props => ({
      ...configuration,
      ...(isFunction(config) ? config(props) : config),
    })),
  )
